import type { FilterKey } from '../../Entities/Search/QueryParams.entity';
import type { Filter } from '../../Entities/Search/SearchFilters/Filter.entity';

export const getFilterFromArray = (id: FilterKey, filters: Filter[]) => {
  return filters.find(fltr => fltr.id === id);
};
